import clsx from "clsx";
import { useTranslation } from "react-i18next";

import illustration from "@/assets/images/illustration.png";
import { Typography } from "@atoms/typography";
import { AuthContent } from "@templates/authManagement/authContent";
import { AuthFooter } from "@templates/authManagement/authFooter";
import { AuthHeader } from "@templates/authManagement/authHeader";

import classes from "./styles.module.scss";

export function AuthContainer() {
  const { t } = useTranslation("common");

  return (
    <div className={clsx(classes.container)}>
      <div className={clsx(classes.container__outside)}>
        <AuthHeader />
        <div className={clsx(classes.container__content)}>
          <AuthContent />
        </div>
        <AuthFooter />
      </div>

      <div className={clsx(classes.container__illustrationContent)}>
        <img
          src={illustration}
          alt={"Illustration"}
          className={clsx(classes.container__img)}
        />
        <div className={clsx(classes.container__textContent)}>
          {/* HINT: themeColor secondary-950 and secondary-600 does not work , so i used css */}
          <Typography
            fontType={"title-h5"}
            className={clsx(classes.container__brandTitle)}
          >
            {t("brand.title")}
          </Typography>
          <Typography
            fontType={"label-medium"}
            className={clsx(classes.container__brandDescription)}
          >
            {t("brand.description")}
          </Typography>
        </div>
      </div>
    </div>
  );
}
